export default __webpack_public_path__ + "static/media/EM0830.34I-22678_-15176_0.4597123b.jpg";